/**
 * 和平台相關的工具方法和常量
 */

import getQuery from './getQuery';

/**
 * 內部維護變量枚舉
 */
export enum UrlPlatform {
  // 一戶通
  personal = 'personal',
  // 一商通
  business = 'business',
}

/**
 * 獲取平台
 */
export const getPlatformFormQuery = () => {
  const { platform } = getQuery();
  switch (platform) {
    // 一戶通
    case 'personal':
      return UrlPlatform.personal;
    // 商社通
    case 'business':
      return UrlPlatform.business;
    default:
      return UrlPlatform.personal;
  }
};

let platform: string | null = getPlatformFormQuery();

export const setPlatform = (_platform: string) => {
  platform = _platform;
};

export const getPlatform = () => platform;

/**
 * 請求頭枚舉
 */
export enum RequestHeaderPlatform {
  // 一戶通
  personal = 'one-account',
  // 一商通
  business = 'association-business',
}

/**
 * 獲取Request Header Origin-Platform 的值
 */
export const getRequestHeaderPlatform = () => {
  switch (getPlatform()) {
    case UrlPlatform.personal:
      return RequestHeaderPlatform.personal;
    case UrlPlatform.business:
      return RequestHeaderPlatform.business;
    default:
      return UrlPlatform.personal;
  }
};

/**
 * 根據平台獲取對應的認證服務器地址
 * @returns
 */
export const getAuthURLByPlatform = () => {
  const authURL: Record<UrlPlatform, string> = {
    [UrlPlatform.personal]: GOV_MO.YHT_AUTH_SERVER,
    [UrlPlatform.business]: GOV_MO.SST_AUTH_SERVER,
  };
  // const { platform } = getQuery();
  // if (!platform) return '';

  return authURL[platform as UrlPlatform] || '';
};
